'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParser = exports.createGenerator = undefined;

var _createGenerator = require('./createGenerator');

var _createGenerator2 = _interopRequireDefault(_createGenerator);

var _createParser = require('./createParser');

var _createParser2 = _interopRequireDefault(_createParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @flow

exports.createGenerator = _createGenerator2.default;
exports.createParser = _createParser2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rst-selector-parser/dist/index.js
// module id = 502
// module chunks = 0